import React from 'react';
import PropTypes from 'prop-types';

import SelectMenu from '../select';

const AssetTypePreferences = ({ assetTypes, setAssetTypes, options, isLoading = false }) => {
	return (
		<div data-testid="preferences-notifications-asset-types-select">
			<SelectMenu
				classNamePrefix="btn-menu-react-select"
				placeholder="Type to search asset types"
				options={options}
				value={assetTypes}
				onChange={(selected) => setAssetTypes(selected || [])}
				isLoading={isLoading}
				isMulti
			/>
		</div>
	);
};

AssetTypePreferences.propTypes = {
	assetTypes: PropTypes.array.isRequired,
	options: PropTypes.array.isRequired,
	setAssetTypes: PropTypes.func.isRequired,
	isLoading: PropTypes.bool
};

export default AssetTypePreferences;
